import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import "../../styles/C2c2c.css";
import ArrowShape from "../icons/ArrowShape";

const items = [
  { id: 1, src: "/assets/C2C2C/c1.jpg", position: "top" },
  { id: 2, src: "/assets/C2C2C/c2.jpg", position: "right" },
  { id: 3, src: "/assets/C2C2C/c3.jpg", position: "bottom" },
];

const Arrow = ({ active }) => {
  const arrowAnimDuration = 3;
  return (
    <motion.div
      className="arrow-wrapper"
      animate={
        active
          ? {
              opacity: [0.3, 1, 0.3],
              color: ["#0096FF", "#0096FF"],
            }
          : { opacity: 0.3, color: "#9CD5FF" }
      }
      transition={{
        opacity: {
          duration: arrowAnimDuration,
          repeat: Infinity,
          ease: "linear",
        },
        color: {
          duration: arrowAnimDuration,
          times: [0, 0.1, 0.9, 1],
          repeat: Infinity,
          ease: "linear",
        },
      }}
    >
      <ArrowShape color="currentColor" size={70} />
    </motion.div>
  );
};

const CircleImage = ({ item, active }) => (
  <motion.div
    className={`c2c2c-image-wrapper ${item.position}`}
    animate={active ? { scale: [1, 1.15, 1] } : { scale: 1 }}
    transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
  >
    <img src={item.src} alt={`Woman ${item.id}`} className="circle-img" />
    <div className="c-badge ">C</div>
  </motion.div>
);

const C2c2c = () => {
  const [step, setStep] = useState(0);

  // Total animation duration: 3 seconds per full cycle (image + arrow per item)
  const totalCycleDuration = 3500; // ms
  const totalSteps = items.length * 2; // Image + Arrow per item = 6 steps for 3 items
  const stepDelay = totalCycleDuration / totalSteps; // e.g. 500 ms per step

  useEffect(() => {
    let timeoutId;

    const runStep = (s) => {
      setStep(s);
      timeoutId = setTimeout(() => runStep((s + 1) % totalSteps), stepDelay);
    };

    runStep(0);

    return () => clearTimeout(timeoutId);
  }, [stepDelay, totalSteps]);

  const isImageStep = step % 2 === 0;
  const activeImageIndex = Math.floor(step / 2);
  // Arrow active right *after* the image step, arrow points from i to (i+1)
  const activeArrowIndex =
    step % 2 === 1 ? Math.floor(step / 2) % items.length : -1;

  return (
    <section className="c2c2c-module bg-primary text-white py-5">
      <Container fluid>
        <Row className="align-items-center">
          <Col md={5} className="position-relative left-section">
            {/* Background layer covering full left section */}
            <div className="background-layer" />

            <div className="circle-container">
              {items.map((item, i) => (
                <React.Fragment key={item.id}>
                  <CircleImage
                    item={item}
                    active={isImageStep && i === activeImageIndex}
                  />
                  <Arrow active={!isImageStep && i === activeArrowIndex} />
                </React.Fragment>
              ))}
            </div>
          </Col>
          <Col md={7} className="right-section d-flex align-items-center">
            <motion.div
              className="c2c2c-right p-4 rounded"
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.9 }}
            >
              <h1 className="c2c2c-title">
                Stay WiSE, Every Step— from Campus to Corporate to Career.
              </h1>
              <p className="c2c2c-text">
                WiSE is your trusted companion at every stage of your journey in
                the semiconductor industry. Whether you’re a student stepping
                into this field, a professional navigating corporate growth, or
                a leader shaping the future, WiSE offers mentorship, resources,
                and a strong community to help you thrive.
              </p>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default C2c2c;
